import { useInfiniteQuery } from '@tanstack/react-query'

import { ApiPaths } from '@/utils/apiPaths'
import { fetchByCityV2 } from '@/utils/parkingsService'

import { ParkingsByCityParams, ParkingsByCityResponseV2 } from '../parkings'

export const useFetchByCity = ({
  slug,
  params
}: {
  slug: string
  params: ParkingsByCityParams
}) => {
  const {
    data,
    isLoading,
    isError,
    error,
    fetchNextPage,
    hasNextPage,
    isFetchingNextPage,
    refetch
  } = useInfiniteQuery<ParkingsByCityResponseV2, Error>({
    queryKey: [ApiPaths.API_V2_PARKINGS, 'allPages', slug, params],
    queryFn: ({ pageParam = 0 }) =>
      fetchByCityV2(slug, {
        ...params,
        //@ts-ignore
        page: pageParam ?? 0,
        size: params.size ?? 0
      }),
    getNextPageParam: (lastPage, allPages) => {
      const totalPages = Math.ceil((lastPage.total ?? 0) / (params.size ?? 10))
      const nextPage = allPages.length
      return nextPage < totalPages ? nextPage : undefined
    },
    initialPageParam: 0
  })
  const parkings = data?.pages?.flatMap(page => page.items) || []
  const total = data?.pages?.[0]?.total ?? 0

  return {
    parkings,
    total,
    isLoading,
    isError,
    error,
    fetchNextPage,
    hasNextPage,
    isFetchingNextPage,
    refetch
  }
}
